import type { core } from '@musinsa/pbo-core'
import type { DailyCloseProductHead, DailyCloseProductItem } from '@/services/inventory/dailyCloseProduct/types'
import { quantityColumn, textColumn } from '../../dailyCloseShared/columns'

type Head = DailyCloseProductHead
type Item = DailyCloseProductItem

export const HEAD_COLUMNS: core.CoreColumnType<Head>[] = [
  textColumn<Head>('shipperCode', '화주코드'),
  textColumn<Head>('shipperName', '화주명', 160),
  textColumn<Head>('serviceType', '화주타입'),
  textColumn<Head>('closeDate', '마감일자'),
  textColumn<Head>('warehouseName', '주문센터', 160),
  quantityColumn<Head>('bohQty', '기초재고'),
  quantityColumn<Head>('normInbPln', '정규입고계획'),
  quantityColumn<Head>('normInbQty', '정규입고실적'),
  quantityColumn<Head>('rsnInbPln', '비정규입고계획'),
  quantityColumn<Head>('rsnInbQty', '비정규입고실적'),
  quantityColumn<Head>('normOubPln', '정규출고계획'),
  quantityColumn<Head>('normOubQty', '정규출고실적'),
  quantityColumn<Head>('rsnOubPln', '비정규출고계획'),
  quantityColumn<Head>('rsnOubQty', '비정규출고실적'),
  quantityColumn<Head>('eohQty', '기말재고'),
  quantityColumn<Head>('adjQty', '조정수량'),
]

export const ITEM_COLUMNS: core.CoreColumnType<Item>[] = [
  textColumn<Item>('shipperCode', '화주코드'),
  textColumn<Item>('shipperName', '화주명', 160),
  textColumn<Item>('serviceType', '화주타입'),
  textColumn<Item>('goodsGroup1', '상품군'),
  textColumn<Item>('brandName', '브랜드명', 160),
  textColumn<Item>('season', '시즌'),
  textColumn<Item>('goodsCode', '상품코드', 160),
  textColumn<Item>('barcode', '바코드', 180),
  textColumn<Item>('goodsOption', '상품옵션', 160),
  quantityColumn<Item>('bohQty', '기초재고'),
  quantityColumn<Item>('normInbPln', '정규입고계획'),
  quantityColumn<Item>('normInbQty', '정규입고실적'),
  quantityColumn<Item>('rsnInbPln', '비정규입고계획'),
  quantityColumn<Item>('rsnInbQty', '비정규입고실적'),
  quantityColumn<Item>('normOubPln', '정규출고계획'),
  quantityColumn<Item>('normOubQty', '정규출고실적'),
  quantityColumn<Item>('rsnOubPln', '비정규출고계획'),
  quantityColumn<Item>('rsnOubQty', '비정규출고실적'),
  quantityColumn<Item>('eohQty', '기말재고'),
  quantityColumn<Item>('availQty', '가용수량'),
  quantityColumn<Item>('adjQty', '조정수량'),
  textColumn<Item>('warehouseName', '주문센터', 160),
]
